// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2iE_e","content":"LayoutSettings_content__3JxZv"};